import Department from './department';

export default Department;
